export function TNS() {
  return (
    <div style={{ color: '#2f3031' }}>
      <p>
        Kementerian Pendidikan Dasar dan Menengah (selanjutnya disebut
        “Kementerian”) adalah suatu badan yang memiliki program platform
        aplikasi yang dapat membantu guru dalam bentuk portal web dan aplikasi.
        Kementerian dalam hal ini menyediakan{' '}
        <span className="italic">platform</span> Ruang GTK dimana Pengguna dapat
        menggunakan fitur dan layanan yang tersedia. Setiap pihak satuan guru
        yang berada di wilayah Negara Kesatuan Republik Indonesia dan Sekolah
        Penggerak dapat mengakses Platform Ruang GTK dan melakukan pemilihan
        perangkat ajar, melakukan asesmen kepada murid, mengumpulkan bukti
        karya, dan melakukan pembelajaran mandiri di dalam satu platform
        tersebut.
      </p>
      <br />
      <p>
        Syarat dan Ketentuan ini mengatur penggunaan seluruh fungsi yang
        terdapat pada Platform Ruang GTK yang berlaku terhadap seluruh pengguna
        dan terhadap setiap Pihak yang menyampaikan permintaan atau informasi
        kepada Kementerian. Dengan melakukan pendaftaran akun dan pengguna yang
        telah diberikan akses kepada Platform dan/atau menggunakan Platform
        Ruang GTK maka pengguna telah membaca, mengerti, memahami dan menyetujui
        seluruh isi dalam Syarat dan Ketentuan ini.
      </p>
      <br />
      <p>
        SYARAT DAN KETENTUAN INI MERUPAKAN BENTUK PERJANJIAN YANG MENGIKAT
        SECARA HUKUM ANTARA PENGGUNA DENGAN KEMENTERIAN. PENGGUNA SECARA SADAR
        DAN SUKARELA MENYETUJUI SYARAT DAN KETENTUAN INI UNTUK MENGGUNAKAN
        LAYANAN DI PLATFORM RUANG GTK. SYARAT DAN KETENTUAN INI DAPAT
        DIPERBAHARUI DARI WAKTU KE WAKTU DAN PENGGUNAAN PLATFORM YANG
        BERKELANJUTAN DIANGGAP SEBAGAI PERSETUJUAN UNTUK TUNDUK PADA PERUBAHAN
        SYARAT DAN KETENTUAN INI.
      </p>

      <br />

      <p>
        <strong>Definisi</strong>
      </p>
      <p>
        Dalam Syarat dan Ketentuan ini, sepanjang tidak ditentukan lain,
        istilah-istilah di bawah ini mempunyai arti sebagai berikut:
      </p>
      <ol className="pl-4 list-decimal">
        <li>
          Pengguna adalah pihak terdaftar yang mengakses Platform Ruang GTK
          termasuk namun tidak terbatas pada Pengguna non-guru
          (mitra/publisher), Pengguna Guru non-Sekolah Penggerak, Pengguna Guru
          Sekolah Penggerak, Pengguna yang mana wajib mematuhi aturan penggunaan
          Platform Ruang GTK beserta ketentuan-ketentuan lain termasuk namun
          tidak terbatas pada Syarat dan Ketentuan Platform Ruang GTK serta
          Kebijakan Privasi Platform Ruang GTK
        </li>
        <li>
          Akun adalah data tentang Pengguna, yang terdaftar pada akun
          pembelajaran Kementerian dan telah diberikan akses ke Platform yang
          dapat diisi oleh Pengguna namun tidak terbatas pada data pendukung
          untuk melakukan eksplorasi pada platform yang terdiri dari Kelas yang
          diajar, Mata Pelajaran, Sekolah dan Provinsi Sekolah tersebut.
        </li>
        <li>
          Platform Ruang GTK adalah aplikasi berbasis Android dan Web yang dapat
          diakses melalui seluler pengguna ataupun{' '}
          <span className="italic">browser</span> perangkat laptop pengguna.
        </li>
        <li>
          Perangkat Ajar adalah suatu bahan ajar yang berupa materi ajar yang
          telah dikaitkan dengan kurikulum baru dan dapat disimpan oleh Pengguna
          untuk dijadikan bahan pengajaran mereka.
        </li>
        <li>
          Layanan adalah secara kolektif: (i) Platform Ruang GTK; (ii) konten,
          fitur, dan fungsi apapun yang tersedia di atau melalui
          <span className="italic"> platform</span> oleh atau atas nama Platform
          Ruang GTK, termasuk layanan Partner, notifikasi, dan integrasi ke{' '}
          <span className="italic">platform</span> penulis pesan eksternal.
        </li>
        <li>
          Syarat dan Ketentuan adalah perjanjian antara Pengguna dan Kementerian
          yang berisi seperangkat ketentuan dan peraturan yang mengatur hak,
          kewajiban, tanggung jawab Pengguna dan Kementerian, serta tata cara
          penggunaan sistem Platform Ruang GTK.
        </li>
        <li>
          Pengguna adalah Pengguna Guru, Pengguna non-guru
          (mitra/penulis/publisher) atau Pengguna Guru-Sekolah Penggerak
          terdaftar yang melakukan penyimpanan perangkat ajar, melakukan asesmen
          atau melakukan pembelajaran serta mengumpulkan bukti karya secara
          elektronik melalui Platform Ruang GTK.
        </li>
        <li>
          Pengguna Internal adalah Pengguna internal dari Kementerian yang
          mendukung dan memberikan konten perangkat ajar untuk dapat diakses
          secara elektronik melalui Platform Ruang GTK.
        </li>
        <li>
          Pengguna Mitra adalah Pengguna eksternal yang mendapatkan akses yang
          mendukung dan memberikan konten perangkat ajar dan non perangkat ajar
          (konten paket soal untuk asesmen) untuk dapat diakses oleh Pengguna
          secara elektronik melalui Platform Ruang GTK.
        </li>
        <li>
          Data / Informasi Pribadi adalah data terkait dengan Pengguna yang
          dapat teridentifikasi dan/atau dapat diidentifikasi secara tersendiri
          atau dikombinasikan dengan informasi lainnya baik secara langsung
          maupun secara tidak langsung melalui sistem elektronik dan/atau
          non-elektronik.
        </li>
      </ol>

      <br />

      <p>
        <strong>Layanan</strong>
      </p>

      <ol className="pl-4 list-decimal">
        <li>
          Platform Ruang GTK mengelola dan menyediakan Platform bagi Pengguna
          non-Guru, Pengguna Guru non-Sekolah Penggerak, Pengguna Guru Sekolah
          Penggerak untuk melakukan pencarian inspirasi pengajaran, belajar dan
          membangun portofolio karir secara elektronik dan Pengguna Internal dan
          serta Pengguna Mitra untuk memberikan konten Perangkat Ajar dan
          Non-Perangkat Ajar secara elektronik pada Platform Ruang GTK yang
          dapat diakses melalui perangkat seluler Pengguna berbasis aplikasi
          Android dan <span className="italic">browser</span> dari laptop
          Pengguna
        </li>
        <li>
          Penyimpanan Perangkat Ajar menyediakan fitur untuk pengguna terhadap
          konten inspirasi pengajaran yang dapat dilakukan di kelas dan
          non-kelas oleh Guru kepada Murid
          <ol className="pl-4" style={{ listStyleType: 'lower-alpha' }}>
            <li>
              Dengan menggunakan layanan ini, Pengguna setuju bahwa:
              <ol className="pl-4">
                <li style={{ listStyleType: 'lower-roman' }}>
                  Fitur ini menyimpan data yang di personalisasi oleh Pengguna
                  berdasarkan kebutuhan mereka untuk melakukan pengajaran
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          Asesmen merupakan fitur konten paket soal yang dapat diberikan oleh
          Guru kepada Murid untuk memahami dan menganalisa tingkat kemampuan
          murid berada di level mana
          <ol className="pl-4" style={{ listStyleType: 'lower-alpha' }}>
            <li>
              Dengan menggunakan layanan ini, Pengguna setuju bahwa:
              <ol className="pl-4">
                <li style={{ listStyleType: 'lower-roman' }}>
                  Fitur ini dapat diberikan ke murid dan Platform akan menyimpan
                  data distribusi dan hasil asesmen dari murid yang dituju
                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li>Pembelajaran Mandiri</li>
        <li>
          Pengumpulan Bukti Karya merupakan fitur untuk Pengguna menyimpan karya
          dalam bentuk dan kategori yang telah ditentukan untuk kemudian
          dijadikan acuan pencapaian kompetensi
          <ol className="pl-4" style={{ listStyleType: 'lower-alpha' }}>
            <li>
              Dengan menggunakan layanan ini, Pengguna setuju bahwa:
              <ol className="pl-4">
                <li style={{ listStyleType: 'lower-roman' }}>
                  Pengguna dilarang menggunakan, menempatkan, mengunduh,
                  menautkan, melekatkan dan atau menayangkan karya yang:
                  <ol className="pl-6">
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      menampilkan wajah dan identitas pihak lain kecuali telah
                      mendapatkan persetujuan terlebih dahulu dari pihak yang
                      ditampilkan tersebut atau wali pihak tersebut yang sah,
                      apabila pihak yang ditampilkan adalah anak dibawah umur.
                    </li>
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      melanggar atau menyalahi hak orang lain, termasuk namun
                      tidak terbatas pada, hak intelektual, hak paten, merek
                      dagang, rahasia dagang, hak cipta, publisitas atau hak
                      milik lainnya dari pihak ketiga;
                    </li>
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      mengancam keselamatan, memfitnah, mencemarkan nama baik,
                      menipu, mencurangi, dan/atau menimbulkan kebencian pada
                      pihak lain, baik individu maupun kelompok;
                    </li>
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      memuat dan/atau berisi informasi palsu atau yang diragukan
                      kebenarannya secara sengaja dengan maksud untuk menipu,
                      membohongi atau memperdaya Pengguna lain;
                    </li>
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      menghina, menyinggung, melecehkan, merendahkan,
                      mengintimidasi, memicu pertentangan dan/atau permusuhan
                      individu maupun kelompok berdasarkan diskriminasi Suku,
                      Agama, Ras dan Antar Golongan (SARA), jenis kelamin,
                      orientasi seksual, usia, cacat fisik, dan/atau mental;
                    </li>
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      melanggar norma kesusilaan, mengandung unsur cabul dan
                      pornografi, termasuk apabila menyediakan akses ke konten
                      bersifat seksual dan/atau secara aktif mempromosikan atau
                      merekomendasikan konten bersifat seksual;
                    </li>
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      memuat kekerasan, darah, adegan menyeramkan yang bertujuan
                      untuk menakut-nakuti, menimbulkan perasaan takut
                      berlebihan, dan/atau dengan cara apapun menggambarkan atau
                      memfasilitasi aktivitas membahayakan dan berbahaya;
                    </li>
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      memuat konten lainnya yang membahayakan anak, termasuk
                      namun tidak terbatas pada konten yang menunjukkan:
                      interaksi bersifat seksual yang tidak pantas yang
                      ditujukan kepada anak, pembujukrayuan (
                      <span className="italic">child grooming</span>) terhadap
                      anak untuk memfasilitasi kontak seksual dan/atau bertukar
                      gambar seksual dengan anak tersebut baik secara{' '}
                      <span className="italic">online</span> maupun{' '}
                      <span className="italic">offline</span>, seksualisasi anak
                      di bawah umur (misalnya gambar yang mendeskripsikan,
                      mendorong, atau mempromosikan baik secara langsung maupun
                      tidak langsung, pelecehan seksual terhadap anak atau
                      penggambaran anak dengan cara-cara yang dapat
                      mengakibatkan eksploitasi seksual terhadap anak-anak).
                    </li>
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      menganjurkan atau menyarankan perbuatan yang melanggar
                      hukum;
                    </li>
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      memuat kata-kata sumpah serapah, gambar, atau bentuk
                      grafis lainnya yang berisi dan/atau menimbulkan rasa
                      terganggu Pengguna lain;
                    </li>
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      menyebarkan ideologi atau ajaran tertentu yang melanggar
                      hukum yang berlaku di wilayah Republik Indonesia;
                    </li>
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      mengandung virus atau kode komputer lainnya, file atau
                      program yang dapat mengganggu, merusak atau membatasi
                      fungsi dari perangkat lunak (
                      <span className="italic">software</span>) atau perangkat
                      keras (<span className="italic">hardware</span>) komputer
                      atau peralatan komunikasi, atau memperbolehkan penggunaan
                      komputer atau jaringan komputer yang tidak sah,
                    </li>
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      melanggar Persyaratan Layanan ini, petunjuk atau kebijakan
                      lainnya yang ada di Platform Ruang GTK.
                    </li>
                  </ol>
                </li>
                <li style={{ listStyleType: 'lower-roman' }}>
                  Karya yang ditampilkan bukan merupakan hasil plagiasi dalam
                  bentuk dan untuk alasan apapun, termasuk penggunaan dan/atau
                  pengutipan sebagian atau seluruh karya dalam bentuk teks, foto
                  dan video milik orang lain serta hal-hal lain yang serupa,
                  seolah-olah itu milik Pengguna, tanpa dengan jelas dan tegas
                  menyebutkan sumber data dan informasinya secara tepat dan
                  memadai.
                </li>
                <li style={{ listStyleType: 'lower-roman' }}>
                  Pengguna wajib mencantumkan kredit pada karya apabila
                  menggunakan musik, gambar, atau karya pihak lain dengan cara:
                  <ol className="pl-6">
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      menyebutkan sumber (nama orang atau pihak pencipta,
                      pemilik, atau pemegang hak cipta) secara langsung atau
                      melalui tautan menuju alamat sumber.
                    </li>
                    <li style={{ listStyleType: 'lower-alpha' }}>
                      menyebutkan sumber lengkap dan jelas untuk konten yang
                      dimuat dalam karya, yang merupakan hasil pencarian dari
                      mesin pencari (tidak dibenarkan hanya menyebut nama/merek
                      mesin pencari sebagai sumbernya).
                    </li>
                  </ol>
                </li>
                <li style={{ listStyleType: 'lower-roman' }}>
                  Pengguna dilarang memuat dan/atau menayangkan konten berisi
                  iklan, promosi, atau sejenisnya yang secara langsung atau
                  tidak langsung atau dalam bentuk tautan (
                  <span className="italic">link</span>) berisi ajakan untuk
                  membeli produk barang atau jasa yang dimaksud dalam konten
                  yang dimuat pada karya.
                </li>
              </ol>
            </li>
          </ol>
        </li>
      </ol>

      <br />

      <p>
        <strong>Pengguna, Akun, Keamanan, dan Password</strong>
      </p>
      <p>
        Persyaratan wajib bagi Pengguna untuk mengakses layanan di Platform
        Ruang GTK, antara lain:
      </p>
      <ol className="pl-4 list-decimal">
        <li>
          Mengakses Platform Ruang GTK dan/atau menggunakan Fitur hanya untuk
          tujuan yang sah dan dengan cara yang sah, setiap saat, dan juga setuju
          untuk melakukan aktivitas apapun terkait Layanan atau Platform Ruang
          GTK dengan itikad baik.
        </li>
        <li>
          Pengguna wajib membaca, memahami serta mengikuti semua ketentuan yang
          diatur dalam Syarat dan Ketentuan ini.
        </li>
        <li>
          Pengguna wajib memiliki akun pembelajaran yang terdaftar di
          Kementerian untuk mengakses platform Ruang GTK.
        </li>
        <li>
          Pengguna yang memiliki akun di Platform Ruang GTK, wajib mengisi data
          sekolah, kelas dan mata pelajaran yang diajar secara lengkap sesuai
          dengan identitas pribadinya.
        </li>
        <li>
          Pengguna wajib memahami bahwa detail informasi akun milik Pengguna
          adalah rahasia, dan karenanya Pengguna tidak akan mengungkapkan detail
          informasi akun Pengguna kepada pihak ketiga mana pun, termasuk
          <span className="italic"> password</span> rahasia email untuk
          melakukan log-in ke Akun Pengguna. Platform Ruang GTK atau petugas
          Kementerian tidak akan menanyakan{' '}
          <span className="italic">password</span> Pengguna (kecuali pada
          halaman di Platform Ruang GTK ketika Pengguna masuk ke platform Ruang
          GTK). Pengguna setuju untuk menanggung setiap risiko terkait
          pengungkapan informasi Akun Pengguna kepada pihak ketiga mana pun dan
          bertanggung jawab penuh atas setiap konsekuensi yang berkaitan dengan
          hal tersebut.
        </li>
        <li>
          Pengguna bertanggung jawab sepenuhnya atas konten yang diunggah
          dan/atau ditampilkan dalam Platform Ruang GTK. Pengguna wajib
          memastikan bahwa konten yang diunggah atau ditampilkan pada Platform
          Ruang GTK adalah sesuai dengan norma, batasan, dan/atau ketentuan
          hukum yang berlaku dan Persyaratan Layanan ini. Apabila ditemukan
          konten yang dinilai melanggar norma, batasan, dan/atau ketentuan hukum
          yang berlaku, maka Kementerian berhak sepenuhnya untuk menurunkan
          konten dan Platform Ruang GTK dan/atau melakukan proses hukum
          lanjutan, apabila diperlukan, sehubungan dengan konten dimaksud.
        </li>
      </ol>

      <br />

      <p>
        <strong>Link Menuju Platform YouTube dan Google</strong>
      </p>

      <ol className="pl-4 list-decimal">
        <li>
          Platform Ruang GTK menggunakan Servis Antarmuka Pemrograman Aplikasi
          YouTube/YouTube
          <span className="italic">
            Application Programming Interface Services
          </span>
          (“YouTube API Services”) untuk fitur yang memungkinkan Pengguna untuk
          menyimpan konten yang dimiliki dari YouTube ke dalam Akun yang
          digunakan pada Aplikasi.Sehubungan dengan penggunaan YouTube API
          Services, Pengguna akan tunduk pada kebijakan penggunaan, kebijakan
          privasi, serta kebijakan layanan lainnya yang ditetapkan, oleh YouTube
          dalam{' '}
          <a
            className="underline text-blue-600"
            href="https://www.youtube.com/t/terms"
          >
            Kebijakan Penggunaan YouTube/YouTube’s Terms of Service.
          </a>
        </li>
        <li>
          Penggunaan platform Google akan tunduk pada{' '}
          <a
            className="underline text-blue-600"
            href="https://policies.google.com/privacy?hl=id"
          >
            Kebijakan Privasi Google
          </a>{' '}
          yang termasuk, namun tidak terbatas pada pengaturan keamanan dan
          pencabutan akses Pengguna yang mungkin dilakukan oleh Google dalam hal
          terjadi penyalahgunaan oleh Pengguna Platform Ruang GTK.
        </li>
        <li>
          Penggunaan platform YouTube akan tunduk pada{' '}
          <a
            className="underline text-blue-600"
            href="https://www.youtube.com/intl/ALL_id/howyoutubeworks/policies/overview/"
          >
            Kebijakan Privasi YouTube
          </a>{' '}
          termasuk, namun tidak terbatas pada pengaturan keamanan dan pencabutan
          akses Pengguna yang mungkin dilakukan oleh YouTube dalam hal terjadi
          penyalahgunaan penggunaan oleh Pengguna Platform Ruang GTK.
        </li>
        <li>
          Dalam hal Pengguna memutuskan untuk ingin mencabut akses Google dan
          YouTube dari data penggunaan di platform terkait. Pengguna dapat
          melakukannya melalui{' '}
          <a
            className="underline text-blue-600"
            href="https://security.google.com/settings/security/permissions"
          >
            halaman pengaturan Google.
          </a>
        </li>
        <li>
          Pengguna setuju bahwa, dalam hal terdapat tautan dan akses ke situs
          web dan konten lain yang disediakan oleh pihak ketiga di luar
          Kementerian Pendidikan, Kebudayaan, Riset dan Teknologi pada Platform
          Ruang GTK, Kementerian tidak memiliki kendali atas konten situs web
          tersebut. Kementerian tidak bertanggung jawab atas bagian apapun dari
          isi konten yang disediakan oleh pihak ketiga, termasuk Google dan
          YouTube.
        </li>
        <li>
          Akses atau penggunaan konten dari pihak ketiga tersebut oleh Pengguna
          merupakan bentuk persetujuan Pengguna untuk tunduk pada kebijakan
          penggunaan, kebijakan privasi serta kebijakan lainnya yang ditetapkan
          oleh pihak ketiga tersebut.
        </li>
        <li>
          Penggunaan tautan menuju Platform oleh pihak ketiga lainnya di luar
          Platform Ruang GTK, diperbolehkan selama tidak melanggar Syarat dan
          Ketentuan serta Kebijakan Privasi dari Platform Ruang GTK.
        </li>
      </ol>
      <br />

      <p>
        <strong>Pembaruan dan Modifikasi Syarat dan Ketentuan</strong>
      </p>
      <p>
        Kementerian memiliki hak untuk melakukan pembaruan dan/atau perubahan
        Syarat dan Ketentuan dari waktu ke waktu jika diperlukan demi keamanan
        dan kenyamanan penggunaan Pengguna di Platform Ruang GTK. Pengguna
        dengan ini setuju bahwa Pengguna bertanggung jawab untuk membaca secara
        saksama dan memeriksa Syarat dan Ketentuan ini dari waktu ke waktu untuk
        mengetahui pembaruan dan/atau perubahan apapun. Dengan tetap mengakses
        dan menggunakan layanan di Platform Ruang GTK, maka Pengguna dianggap
        menyetujui pembaruan dan/atau perubahan dalam Aturan Penggunaan ini.
      </p>

      <br />

      <p>
        <strong>Pengecualian Tanggung Jawab</strong>
      </p>
      <ol className="pl-4" style={{ listStyleType: 'upper-roman' }}>
        <li>
          Platform Ruang GTK mengambil langkah-langkah teknis dan keamanan yang
          sesuai dan wajar untuk menjaga agar Platform Ruang GTK tetap aman dan
          bebas dari virus dan kesalahan. Namun, meskipun teknologi ini efektif,
          tidak ada sistem keamanan yang tidak dapat ditembus. Dengan demikian,
          kami tidak dapat menjamin keamanan basis data kami maupun menjamin
          bahwa informasi yang Pengguna berikan tidak akan dihadang saat
          dikirimkan kepada Platform Ruang GTK. Kementerian akan
          menginformasikan kepada Pengguna secara tertulis apabila Kementerian
          mengetahui bahwa terdapat pelanggaran keamanan data yang melibatkan
          informasi pribadi Pengguna.
        </li>
        <li>
          Platform Ruang GTK dapat mengalami pembatasan, penundaan, dan masalah
          lain terkait penggunaan internet dan komunikasi elektronik, termasuk
          kecacatan perangkat yang digunakan oleh Pengguna, tidak terhubung, di
          luar jangkauan, tidak aktif, atau tidak berfungsi. Kementerian tidak
          bertanggung jawab atas kerugian apa pun akibat masalah-masalah
          tersebut.
        </li>
      </ol>
    </div>
  )
}
